<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let permission: string;
	//Constants
	const permissions = ["USER", "STOREOWNER"];
	//Variables
	//Functions
	//Do

</script>

{#each permissions as permissionType}
	<label
		t-id={permissionType}
		class={`radio ${permission}`}
		class:active={permissionType === permission}>
		{#if permissionType === 'STOREOWNER'}STORE OWNER{:else}{permissionType}{/if}
		<input
			type="radio"
			bind:group={permission}
			name="permission"
			value={permissionType} />
	</label>
{/each}

<style lang="scss">
	.radio {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 15px;
		box-sizing: border-box;
		height: 28px;
		color: #bcbfc3;
		font-size: 0.875rem;

		border: 1px solid #bcbfc3;
		border-radius: 20px;

		input {
			display: none;
		}
		&:hover {
			cursor: pointer;
		}

		&.active {
			font-weight: 500;
			color: white;
			border: none;

			&.USER {
				background-color: #6d6f76;
			}
			&.STOREOWNER {
				background-color: #6591fa;
			}
		}
	}

</style>
